import { motion } from 'framer-motion';

const ACCENTS = {
  emerald: {
    bar: 'bg-[#1e9f6b]',
    tag: 'text-[#1e9f6b]',
    icon: 'bg-[#1e9f6b] shadow-[#1e9f6b]/25',
  },
  rose: {
    bar: 'bg-rose-500',
    tag: 'text-rose-500',
    icon: 'bg-rose-500 shadow-rose-500/25',
  },
};

export function AdminPageHeader({
  tag,
  title,
  subtitle,
  icon,
  accent = 'emerald',
  children,
  className = '',
}) {
  const a = ACCENTS[accent] || ACCENTS.emerald;

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className={`flex flex-col sm:flex-row justify-between items-start sm:items-end gap-6 ${className}`}
    >
      <div className="flex items-start gap-4">
        {icon ? (
          <div
            className={`h-12 w-12 rounded-2xl flex items-center justify-center shadow-lg flex-shrink-0 ${a.icon}`}
          >
            <span
              className="material-symbols-outlined text-white text-[26px]"
              style={{ fontVariationSettings: "'FILL' 1" }}
            >
              {icon}
            </span>
          </div>
        ) : null}
        <div>
          {tag ? (
            <div className="flex items-center gap-2 mb-3">
              <div className={`h-1.5 w-8 rounded-full ${a.bar}`} />
              <span className={`text-[10px] font-black uppercase tracking-[0.3em] italic ${a.tag}`}>
                {tag}
              </span>
            </div>
          ) : null}
          <h1 className="text-4xl font-black text-slate-900 dark:text-white italic uppercase tracking-tighter">
            {title}
          </h1>
          {subtitle ? (
            <p className="text-slate-500 font-bold italic uppercase text-[10px] tracking-widest mt-2 opacity-70">
              {subtitle}
            </p>
          ) : null}
        </div>
      </div>
      {children ? <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">{children}</div> : null}
    </motion.div>
  );
}
